<main class="inside" *ngIf="!isErr; else idNotFound">
    <section class="first_screen">
        <div class="page">
            <form class="search_block">
                <div class="tag_search_bar">
                    <div class="selected_tag_list">
                        <input type="text" placeholder="The Wave, Arizona">
                    </div>
                    <button>GO ></button>
                </div>
            </form>
        </div>
    </section>

    <section class="book_page page">
        <div class="popup">
            <div class="cnt">
                <h1 class="title_page">{{header}}</h1>
                <div class="location">{{subHeader}}</div>
                <app-star-comonent [category]="category"></app-star-comonent>
                <form (ngSubmit)="toggleSubmitAllData()" #submitForm="ngForm">
                    <div class="flex_block">
                        <div class="left">
                            <div class="selects">
                                <div class="select">
                                    <label> {{'booking-inquiry.accommodation' | translate}}:</label>
                                    <div class="styled-select slate">
                                        <select required (change)="priceIndex(priceID); totalPrice()" style="cursor:pointer" [(ngModel)]="priceID" name="roomType">
                                          <option [value]=null selected disabled>--</option>
                                              <option *ngFor="let roomTy of roomTypes; let i = index"  [ngValue]="i">{{roomTy.roomTypeName}}</option>
                                            </select>
                                    </div>
                                </div>
                                <div class="select">
                                    <label>{{'booking-inquiry.date' | translate}}:</label>
                                    <div class="styled-select slate" *ngIf="priceID == 0; else elseDate1">
                                        <select required (change)="selectedDate(dateID); totalPrice();priceIndex(priceID)" style="cursor:pointer" [(ngModel)]="dateID" name="singleRooms">
                                              <option [ngValue]='null' selected disabled>--</option>
                                              <option  *ngFor="let single of SingleRoom;let i=index" [selected]="0" [ngValue]="i">{{single.start | date: 'dd.MM.yyyy'}} - {{single.end | date: 'dd.MM.yyyy'}}</option>
                                            </select>
                                    </div>
                                    <ng-template #elseDate1>
                                        <div class="styled-select slate">
                                            <select required (change)="selectedDate(dateID); totalPrice();priceIndex(priceID)" style="cursor:pointer" [(ngModel)]="dateID" name="doubleRooms">
                                            <option [ngValue]='null' selected disabled>--</option>
                                                <option  *ngFor="let single of DoubleRoom;let i=index" [selected]="0" [ngValue]="i">{{single.start | date: 'dd.MM.yyyy'}} - {{single.end | date: 'dd.MM.yyyy'}}</option>
                                                </select>
                                        </div>
                                    </ng-template>
                                </div>
                                <div class="select">
                                    <label>{{'booking-inquiry.flight' | translate}}:</label>
                                    <div class="styled-select slate">
                                        <select required (change)="selectFlight(airport); totalPrice()" style="cursor:pointer" [(ngModel)]="airport" name="airport">
                                       <option [ngValue]='null' selected disabled>--</option>
                                              <option *ngFor="let f of flightFrom; let i = index" [selected]="0"  [ngValue]="i">{{f.airportName}}&nbsp;&nbsp;&nbsp;&nbsp;  {{f.pricee}}</option>
                                            </select>
                                    </div>
                                </div>
                                <div class="select">
                                    <label>{{'booking-inquiry.board' | translate}}:</label>
                                    <div class="styled-select slate">
                                        <select required (change)="selectBoardType(boardType); totalPrice()" style="cursor:pointer" [(ngModel)]="boardType" name="boardType">
                                              <option [ngValue]="99999"  selected="99999">{{firstBoardType}}&nbsp;&nbsp;&nbsp;&nbsp; 0.00€
                                                  </option>
                                              <option *ngFor="let b of boardUpgrades; let i = index"   selected="i == 99999" [ngValue]="i">{{b.boardTypeName}} &nbsp;&nbsp;&nbsp;&nbsp; {{b.pricee}}</option>
                                            </select>
                                    </div>
                                </div>
                            </div>
                            <div class="result_select">
                                <div *ngIf="lowestPriceIndex == 1">
                                    <div class="flex_block">
                                        <span>{{'booking-inquiry.price-pp' | translate}}:</span>
                                        <span> <span *ngIf="!airportChoosen || !dateChoosen">{{'booking-inquiry.from' | translate}}</span> {{priceForSingle}}</span>
                                    </div>
                                    <div class="flex_block big">
                                        <span>{{'booking-inquiry.price-total' | translate}}:</span>
                                        <span><span *ngIf="!airportChoosen || !dateChoosen">{{'booking-inquiry.from' | translate}}</span> {{priceForSingle1}}</span>
                                    </div>
                                </div>
                                <div *ngIf="lowestPriceIndex == 2">
                                    <div class="flex_block">
                                        <span>{{'booking-inquiry.price-pp' | translate}}:</span>
                                        <span><span *ngIf="!airportChoosen || !dateChoosen">{{'booking-inquiry.from' | translate}}</span> {{priceForDouble}}</span>
                                    </div>
                                    <div class="flex_block big">
                                        <span>{{'booking-inquiry.price-total' | translate}}:</span>
                                        <span><span *ngIf="!airportChoosen || !dateChoosen">{{'booking-inquiry.from' | translate}}</span> {{priceForDouble1}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="inputs">
                            <div class="checkboxes">
                                <div class="label">{{'booking-inquiry.salutation' | translate}}:</div>
                                <div class="checkbox_s">
                                    <input type="radio" name="gender" id="Anrede1" value={{manCode}} #salutationB required [(ngModel)]="submitData.salutationB">
                                    <label for="Anrede1">{{man}}</label>
                                </div>
                                <div class="checkbox_s">
                                    <input type="radio" name="gender" id="Anrede2" value={{womanCode}} #salutationB [required]="submitData.salutationB != ''" [(ngModel)]="submitData.salutationB">
                                    <label for="Anrede2">{{woman}}</label>
                                </div>
                            </div>
                            <div class="flex_block">
                                <div class="field_input">
                                    <div class="label">{{'booking-inquiry.first-name' | translate}}:</div>
                                    <input type="text" id="firstNameB" name="firstNameB" maxlength="80" required [(ngModel)]="submitData.firstNameB" #firstNameB="ngModel">
                                    <div *ngIf="firstNameB.invalid && (firstNameB.dirty || firstNameB.touched)" class="alert alert-danger">
                                        <div *ngIf="firstNameB.errors.required">
                                            {{'booking-inquiry-errors.first-name-required' | translate}}
                                        </div>
                                        <div *ngIf="firstNameB.errors.maxlength">
                                            {{'booking-inquiry-errors.first-name-maxlength' | translate}}
                                        </div>
                                    </div>
                                </div>
                                <div class="field_input">
                                    <div class="label">{{'booking-inquiry.last-name' | translate}}:</div>
                                    <input type="text" id="lastNameB" name="lastNameB" maxlength="80" required [(ngModel)]="submitData.lastNameB" #lastNameB="ngModel">
                                    <div *ngIf="lastNameB.invalid && (lastNameB.dirty || lastNameB.touched)" class="alert alert-danger">
                                        <div *ngIf="lastNameB.errors.required">
                                            {{'booking-inquiry-errors.last-name-required' | translate}}
                                        </div>
                                        <div *ngIf="lastNameB.errors.maxlength">
                                            {{'booking-inquiry-errors.last-name-maxlength' | translate}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex_block">
                                <div class="field_input">
                                    <div class="label">{{'booking-inquiry.street' | translate}}:</div>
                                    <input type="text" id="street" name="street" maxlength="80" required [(ngModel)]="submitData.street" #street="ngModel">
                                    <div *ngIf="street.invalid && (street.dirty || street.touched)" class="alert alert-danger">
                                        <div *ngIf="street.errors.required">
                                            {{'booking-inquiry-errors.street-required' | translate}}
                                        </div>
                                        <div *ngIf="street.errors.maxlength">
                                            {{'booking-inquiry-errors.street-maxlength' | translate}}
                                        </div>
                                    </div>
                                </div>
                                <div class="field_input">
                                    <div class="label">{{'booking-inquiry.street-number' | translate}}:</div>
                                    <input type="text" id="streetNum" name="streetNum" maxlength="10" required [(ngModel)]="submitData.streetNum" #streetNum="ngModel">
                                    <div *ngIf="streetNum.invalid && (streetNum.dirty || streetNum.touched)" class="alert alert-danger">
                                        <div *ngIf="streetNum.errors.required">
                                            {{'booking-inquiry-errors.street-number-required' | translate}}
                                        </div>
                                        <div *ngIf="streetNum.errors.maxlength">
                                            {{'booking-inquiry-errors.street-number-maxlength' | translate}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex_block">
                                <div class="field_input-flex">
                                    <div class="field_input">
                                        <div class="label">{{'booking-inquiry.country' | translate}}:</div>
                                        <select id="country" name="country" required [(ngModel)]="submitData.country" #country="ngModel">
                                          <option *ngFor="let count of countries; let i = index" [selected]="i == 56"  [value]="count.code" >{{count.code}}</option>
                                        </select>
                                        <div *ngIf="country.invalid && (country.dirty || country.touched)" class="alert alert-danger">
                                            <div *ngIf="country.errors.required">
                                                {{'booking-inquiry-errors.country-required' | translate}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field_input">
                                        <div class="label">{{'booking-inquiry.zip' | translate}}:</div>
                                        <input type="text" class="inputTest1" type="text" id="zip" name="zip" maxlength="10" required [(ngModel)]="submitData.zip" #zip="ngModel">
                                        <div *ngIf="zip.invalid && (zip.dirty || zip.touched)" class="alert alert-danger">
                                            <div *ngIf="zip.errors.required">
                                                {{'booking-inquiry-errors.zip-required' | translate}}
                                            </div>
                                            <div *ngIf="zip.errors.maxlength">
                                                {{'booking-inquiry-errors.zip-maxlength' | translate}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field_input">
                                    <div class="label"> {{'booking-inquiry.city' | translate}}:</div>
                                    <input type="text" id="city" name="city" maxlength="80" required [(ngModel)]="submitData.city" #city="ngModel">
                                    <div *ngIf="city.invalid && (city.dirty || city.touched)" class="alert alert-danger">
                                        <div *ngIf="city.errors.required">
                                            {{'booking-inquiry-errors.city-required' | translate}}
                                        </div>
                                        <div *ngIf="city.errors.maxlength">
                                            {{'booking-inquiry-errors.city-maxlength' | translate}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex_block">
                                <div class="field_input">
                                    <div class="label">{{'booking-inquiry.phone' | translate}}:</div>
                                    <input type="text" id="phone" name="phone" required maxlength="20" [(ngModel)]="submitData.phone" #phone="ngModel">
                                    <div *ngIf="phone.invalid && (phone.dirty || phone.touched)" class="alert alert-danger">
                                        <div *ngIf="phone.errors.required">
                                            {{'booking-inquiry-errors.phone-required' | translate}}
                                        </div>
                                        <div *ngIf="phone.errors.maxlength">
                                            {{'booking-inquiry-errors.phone-maxlength' | translate}}
                                        </div>
                                    </div>
                                </div>
                                <div class="field_input">
                                    <div class="label">{{'booking-inquiry.email' | translate}}:</div>
                                    <input type="text" email id="email" name="email" required [(ngModel)]="submitData.email" #email="ngModel">
                                    <div *ngIf="email.invalid && (email.dirty || email.touched)" class="alert alert-danger">
                                        <div *ngIf="email.errors.required">
                                            {{'booking-inquiry-errors.email-required' | translate}}
                                        </div>
                                        <div *ngIf="email.errors.email">
                                            {{'booking-inquiry-errors.email-email' | translate}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h3>{{'booking-inquiry.participant' | translate}}:</h3>
                            <div class="flex_block">
                                <table *ngIf="numberOfParticipiants == 1; else elseParticipiants">
                                    <tr>
                                        <th>{{'booking-inquiry.salutation' | translate}}:</th>
                                        <th>{{'booking-inquiry.first-name' | translate}}:</th>
                                        <th>{{'booking-inquiry.last-name' | translate}}:</th>
                                        <th>{{'booking-inquiry.date-born' | translate}}:</th>
                                    </tr>
                                    <tr>
                                        <td><select id="salutation" name="salutation" required [(ngModel)]="submitData.salutation" #salutation="ngModel">
                                            <option [ngValue]='null' selected disabled>--</option>
                                            <option *ngFor="let salut of salutations; let i = index"  [selected]="i == 1" [value]="salut.code" >{{salut.name}}</option>
                                          </select>
                                        </td>
                                        <td><input type="text" id="firstName" name="firstName" minlength="2" required [(ngModel)]="submitData.firstName" #firstName="ngModel"></td>
                                        <td><input type="text" id="lastName" name="lastName" minlength="2" required [(ngModel)]="submitData.lastName" #lastName="ngModel"></td>
                                        <!-- <td><input type="date" id="dateBirth" name="dateBirth" max="2000-12-31" min="1950-12-31" required [(ngModel)]="submitData.dateBirth" #dateBirth="ngModel"></td> -->
                                        <div class="input-group">
                                            <input required class="form-control" style="float:none" placeholder="{{'booking-inquiry.select-date' | translate}}" ngx-mydatepicker name="mydate" [(ngModel)]="test" [options]="myOptions" #dp="ngx-mydatepicker" (dateChanged)="onDateChanged($event, 'dateBirth')" />

                                            <span class="input-group-btn">
                                              <button type="button"  class="btn btn-default date-picker" (click)="dp.clearDate()">
                                                  <i class="glyphicon glyphicon-remove"></i>
                                              </button>
                                              <button type="button" class="btn btn-default date-picker" (click)="dp.toggleCalendar()">
                                                  <i class="glyphicon glyphicon-calendar"></i>
                                              </button>
                                          </span>
                                        </div>
                                    </tr>

                                    <td>
                                        <div *ngIf="salutation.invalid && (salutation.dirty || salutation.touched)" class="alert alert-danger">
                                            <div *ngIf="salutation.errors.required">
                                                {{'booking-inquiry-errors.participant-salutation-required' | translate}}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" class="alert alert-danger">
                                            <div *ngIf="firstName.errors.required">
                                                {{'booking-inquiry-errors.participant-first-name-required' | translate}}
                                            </div>
                                            <div *ngIf="firstName.errors.minlength">
                                                {{'booking-inquiry-errors.participant-first-name-minlength' | translate}}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="alert alert-danger">
                                            <div *ngIf="lastName.errors.required">
                                                {{'booking-inquiry-errors.participant-last-name-required' | translate}}
                                            </div>
                                            <div *ngIf="lastName.errors.minlength">
                                                {{'booking-inquiry-errors.participant-last-name-minlength' | translate}}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <!-- <div *ngIf="dateBirth.invalid && (dateBirth.dirty || dateBirth.touched)" class="alert alert-danger">
                                            <div *ngIf="dateBirth.errors.required">
                                                Geb.-Datum is required.
                                            </div>
                                        </div> -->
                                    </td>
                                </table>


                                <ng-template #elseParticipiants>
                                    <table>
                                        <tr>
                                            <th>{{'booking-inquiry.salutation' | translate}}:</th>
                                            <th>{{'booking-inquiry.first-name' | translate}}:</th>
                                            <th>{{'booking-inquiry.last-name' | translate}}:</th>
                                            <th>{{'booking-inquiry.date-born' | translate}}:</th>
                                        </tr>
                                        <tr>
                                            <td><select id="salutation" name="salutation" required [(ngModel)]="submitData.salutation" #salutation="ngModel">
                                                <option [ngValue]='null' selected disabled>--</option>
                                                <option *ngFor="let salut of salutations; let i = index"  [selected]="i == 1" [value]="salut.code" >{{salut.name}}</option>
                                              </select>
                                            </td>
                                            <td><input type="text" id="firstName" name="firstName" minlength="2" required [(ngModel)]="submitData.firstName" #firstName="ngModel">
                                            </td>
                                            <td><input type="text" id="lastName" name="lastName" minlength="2" required [(ngModel)]="submitData.lastName" #lastName="ngModel"></td>
                                            <!-- <td><input type="date" id="dateBirth" name="dateBirth" max="2000-12-31" min="1950-12-31" required [(ngModel)]="submitData.dateBirth" #dateBirth="ngModel"></td> -->
                                            <td>
                                                <div class="input-group">
                                                    <input required class="form-control" style="float:none" placeholder="{{'booking-inquiry.select-date' | translate}}" ngx-mydatepicker name="mydate" [(ngModel)]="test" [options]="myOptions" #dp="ngx-mydatepicker" (dateChanged)="onDateChanged($event, 'dateBirth')" />

                                                    <span class="input-group-btn">
                                                    <button type="button"  class="btn btn-default date-picker" (click)="dp.clearDate()">
                                                        <i class="glyphicon glyphicon-remove"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-default date-picker" (click)="dp.toggleCalendar()">
                                                        <i class="glyphicon glyphicon-calendar"></i>
                                                    </button>
                                                </span>
                                                </div>
                                            </td>
                                        </tr>
                                        <td>
                                            <div *ngIf="salutation.invalid && (salutation.dirty || salutation.touched)" class="alert alert-danger">
                                                <div *ngIf="salutation.errors.required">
                                                    {{'booking-inquiry-errors.participant-salutation-required' | translate}}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" class="alert alert-danger">
                                                <div *ngIf="firstName.errors.required">
                                                    {{'booking-inquiry-errors.participant-first-name-required' | translate}}
                                                </div>
                                                <div *ngIf="firstName.errors.minlength">
                                                    {{'booking-inquiry-errors.participant-first-name-minlength' | translate}}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="alert alert-danger">
                                                <div *ngIf="lastName.errors.required">
                                                    {{'booking-inquiry-errors.participant-last-name-required' | translate}}
                                                </div>
                                                <div *ngIf="lastName.errors.minlength">
                                                    {{'booking-inquiry-errors.participant-last-name-minlength' | translate}}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <!-- <div *ngIf="dateBirth.invalid && (dateBirth.dirty || dateBirth.touched)" class="alert alert-danger">

                                                <div *ngIf="dateBirth.errors.required">
                                                    Geb.-Datum is required.
                                                </div>
                                            </div> -->
                                        </td>
                                        <tr>
                                            <td><select id="salutation1" name="salutation1" required [(ngModel)]="submitData.salutation1" #salutation1="ngModel">
                                                <option [ngValue]='null' selected disabled>--</option>
                                                <option *ngFor="let salut of salutations; let i = index"  [selected]="i == 1" [value]="salut.code" >{{salut.name}}</option>
                                              </select> </td>
                                            <td><input type="text" id="firstName1" name="firstName1" minlength="2" required [(ngModel)]="submitData.firstName1" #firstName1="ngModel">
                                            </td>
                                            <td><input type="text" id="lastName1" name="lastName1" minlength="2" required [(ngModel)]="submitData.lastName1" #lastName1="ngModel"></td>
                                            <!-- <td><input type="date" id="dateBirth1" name="dateBirth1" max="2000-12-31" min="1950-12-31" (change)="onDateChanged(submitData.dateBirth1)" required [(ngModel)]="submitData.dateBirth1" #dateBirth1="ngModel"></td> -->
                                            <div class="input-group">
                                                <input required class="form-control" style="float:none" [(ngModel)]="test1" placeholder="{{'booking-inquiry.select-date' | translate}}" ngx-mydatepicker name="mydate1" [options]="myOptions" #dp1="ngx-mydatepicker" (dateChanged)="onDateChanged($event, 'dateBirth1')" />

                                                <span class="input-group-btn">
                                                  <button type="button"  class="btn btn-default date-picker" (click)="dp1.clearDate()">
                                                      <i class="glyphicon glyphicon-remove"></i>
                                                  </button>
                                                  <button type="button" class="btn btn-default date-picker" (click)="dp1.toggleCalendar()">
                                                      <i class="glyphicon glyphicon-calendar"></i>
                                                  </button>
                                              </span>
                                            </div>
                                        </tr>
                                        <td>
                                            <div *ngIf="salutation1.invalid && (salutation1.dirty || salutation1.touched)" class="alert alert-danger">
                                                <div *ngIf="salutation1.errors.required">
                                                    {{'booking-inquiry-errors.participant-salutation-required' | translate}}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div *ngIf="firstName1.invalid && (firstName1.dirty || firstName1.touched)" class="alert alert-danger">
                                                <div *ngIf="firstName1.errors.required">
                                                    {{'booking-inquiry-errors.participant-first-name-required' | translate}}
                                                </div>
                                                <div *ngIf="firstName1.errors.minlength">
                                                    {{'booking-inquiry-errors.participant-first-name-minlength' | translate}}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div *ngIf="lastName1.invalid && (lastName1.dirty || lastName1.touched)" class="alert alert-danger">
                                                <div *ngIf="lastName1.errors.required">
                                                    {{'booking-inquiry-errors.participant-last-name-required' | translate}}
                                                </div>
                                                <div *ngIf="lastName1.errors.minlength">
                                                    {{'booking-inquiry-errors.participant-last-name-minlength' | translate}}
                                                </div>
                                            </div>
                                        </td>
                                        <!-- <td>
                                            <div *ngIf="dateBirth1.invalid && (dateBirth1.dirty || dateBirth1.touched)" class="alert alert-danger">
                                                <div *ngIf="dateBirth1.errors.required">
                                                    Geb.-Datum is required.
                                                </div>
                                            </div>
                                        </td> -->
                                    </table>
                                </ng-template>
                            </div>
                            <br>
                            <div class="tac">
                                <!-- <b><a style="cursor:pointer" (click)="openInNewTab('http://www.tos-online.com/agb_ta.html');">Allgemeine Geschäftsbedingungen.</a>:</b> -->
                                <!-- Ich habe die allgemeinen Geschäftsbedingungen zur Kenntnis genommen und akzeptiere diese für mich und meine Mitreisenden. -->
                                <div class="checkbox_s">

                                    <p> <input type="checkbox" id="qwe" [checked]="submitData.checked" (change)="toggleChekbox()"><label for="qwe" id="terms-conditions"></label> {{'booking-inquiry.terms-first-part' | translate}} <a style="cursor:pointer"
                                            (click)="openInNewTab('https://www.tos-online.com/agb_ta.html');">{{'booking-inquiry.terms-second-part' | translate}}</a> {{'booking-inquiry.terms-third-part' | translate}} </p>
                                    <!-- <p><a style="cursor:pointer" (click)="openInNewTab('http://www.tos-online.com/agb_ta.html');">Allgemeine Geschäftsbedingungen.</a></p> -->
                                </div>
                                <button class="btn o" type="submit" [disabled]="!submitForm.form.valid || submitData.checked == false || countSentBookings !== 0">{{'booking-inquiry.booking-btn' | translate}}</button>
                                <button class="btn g" (click)="back()">{{'detailsPage.back-button' | translate}}</button>
                            </div>
                        </div>


                    </div>
                </form>

            </div>
        </div>
    </section>
    <button type="button" hidden="true" class="btn btn-info btn-lg" data-toggle="modal" id="open-modal-booking" data-target="#confirmModal">Open Modal</button>

    <app-confirm-modal [confirmData]="confirmData"></app-confirm-modal>
</main>


<ng-template #idNotFound>
    <div class="page">

        <h1 class="title_pages">{{err}}</h1>
        <button class="btn btn-warning" (click)="back()">Zurück</button>
    </div>

</ng-template>


// WEBPACK FOOTER //
// ./src/app/details/booking/booking.component.html